import React from "react";

import { Flex, ParagraphLg, Title } from "@olist/design-system";

interface IErrorHandlingProps {
  image: JSX.Element;
  title?: string;
  subtitle?: string;
}

export function ErrorHandling({ image, subtitle, title }: IErrorHandlingProps) {
  return (
    <Flex alignItems="center" flexDirection="column">
      {image}
      <Title color="neutral.stronger">{title}</Title>
      <ParagraphLg color="neutral.base">{subtitle}</ParagraphLg>
    </Flex>
  );
}
